import React from 'react';

const CallToAction = () => {
  return (
    <section className="section light" id="cta">
      <h2 className="section-title">Experience Smarter, Cleaner Energy</h2>
      <p className="section-subtitle">
        Discover how MICRO 24 can reduce your fuel costs and emissions from day
        one.
      </p>
      <div style={{ textAlign: 'center' }}>
        <a href="#contact" className="btn btn-primary">
          Get in Touch
        </a>
      </div>
    </section>
  );
};

export default CallToAction;